<template>
  <div class="department-management-redirect"></div>
</template>

<script>
export default {
  name: "DepartmentManagement",
  created() {
    this.$router.replace("/admin/job-type");
  },
};
</script>
